export default __webpack_public_path__ + "img/StokesRewardsLogo-01.png";